const doc = [({"da":({"js":({"admin":({"surveys":({"nav":({"judges":"Dommere"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;